module.exports = __webpack_public_path__ + "img/MGH-Toyosu-8-2440x1172.d7228ef8.jpg";